import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ErrorService } from '../../services/error.service';
import { AdminHeaderClassifierService } from '../../services/admin/admin-headerclassifier.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { Constants, EmailType, Language } from '../../global/constants';

@Component({
  selector: 'app-admin-header-classifier',
  templateUrl: './admin-header-classifier.component.html'
})
export class AdminHeaderClassifierComponent implements OnInit {

  loadingPage = true;
  editTrainingDialogRef: BsModalRef;

  training: any[] = [];
  currentTraining: any = {
    header: '',
    reply: true
  };

  typeLabel: string = "Reply";

  constructor(private errorService: ErrorService,
              private modalService: BsModalService,
              private adminHeaderClassifierService: AdminHeaderClassifierService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.refreshTraining();
  }

  editTraining(dialog, reply: boolean) {
    this.currentTraining.header = '';
    if (reply) {
      this.currentTraining.reply = true;
      this.typeLabel = "Reply";
    }
    else {
      this.currentTraining.reply = false;
      this.typeLabel = "Non-Reply";
    }

    this.editTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  saveTraining() {
    this.adminHeaderClassifierService.newHeaderTraining(this.currentTraining).subscribe(
      (result: any) => {
        this.globalMessageService.message('Added header');
        this.refreshTraining();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-header-classifier.component', 'editTraining.200');
      }
    )
  }

  deleteTraining(header: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this header: "${header.header}"`,
        confirm: function() {
          me.adminHeaderClassifierService.deleteHeaderTraining(header._id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Header was deleted');
              me.refreshTraining();
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'admin-header-classifier.component', 'delete');
            });
        }
      }
    }));
  }

  private refreshTraining() {
    this.loadingPage = true;
    this.adminHeaderClassifierService.getHeaderTraining()
    .subscribe(
      (result: any) => {
        this.training = result;
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-header-classifier.component', 'refreshTraining.100');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-header-classifier/admin-header-classifier.component.ts